import React, { useMemo } from 'react';

import { useFormContext } from 'react-hook-form';

import classes from './MealPlanTable.module.scss';
import { MealHeaderRow } from '../MealHeaderRow/MealHeaderRow';
import { MealRow } from '../MealRow/MealRow';
import { TotalRow } from '../TotalRow/TotalRow';
import { CaloriesPercentsRow } from '../CaloriesPercentsRow/CaloriesPercentsRow';
import { NutrientInfoBlock } from '../NutrientInfoBlock/NutrientInfoBlock';
import { WaterSetupBlock } from '../WaterSetupBlock/WaterSetupBlock';
import { getMealsListForMealsPerDay } from '../../../../shared/utils/mealUtils';
import { MealPlansMacrosFormValues } from '../../../interfaces/MealPlan';
import { MealGridContainer } from '../MealGridContainer/MealGridContainer';

type MealPlanTableProps = {
  nameIndex: number;
  isEditMode: boolean;
};

const MealPlanTable = ({ nameIndex, isEditMode }: MealPlanTableProps) => {
  const { watch } = useFormContext<MealPlansMacrosFormValues>();
  const mealsPerDay = watch(`mealPlans.${nameIndex || 0}.mealPlan`);
  const mealsList = useMemo(
    () => getMealsListForMealsPerDay(+mealsPerDay),
    [mealsPerDay],
  );

  return (
    <div>
      <MealGridContainer className={classes.mealPlanTable}>
        <MealHeaderRow />
        {mealsList.map((meal) => (
          <MealRow
            meal={meal}
            mealFormKey={`mealPlans.${nameIndex}.${meal}`}
            key={meal}
            isEditMode={isEditMode}
          />
        ))}
        <TotalRow nameIndex={nameIndex} />
        {!isEditMode && <CaloriesPercentsRow nameIndex={nameIndex} />}
      </MealGridContainer>
      <NutrientInfoBlock nameIndex={nameIndex} className={classes.nutrientInfoBlock} />
      <WaterSetupBlock nameIndex={nameIndex} isEditMode={isEditMode} />
    </div>
  );
};

export { MealPlanTable };
